import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'
import LogoTiles from '@segment/templates/LogoTiles'
import DividerSection from '@segment/templates/DividerSection'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import PartnerWithSegment from './components/PartnerWithSegment'
import LookingForPartner from './components/LookingForPartner'
import GetStarted from './components/GetStarted'

import ogImage from './assets/OgChannel.png'

const ChannelView = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Become a Twilio Segment Channel Partner | Twilio Segment"
        pageDescription="Develop new revenue streams by helping companies implement their customer data infrastructure."
        pageOG={ogImage}
      >
        <NavigationV2 />
        <Hero />
        <Main>
          <PartnerWithSegment />
          <DividerSectionWrapper>
            <DividerSection />
          </DividerSectionWrapper>
          <LookingForPartner />
          <LightGrayBackground>
            <GetStarted />
            <LogoTiles />
          </LightGrayBackground>
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};

  ${({ theme }) => theme.breakpoints.down(`xl`)} {
    overflow-x: hidden;
  }
`

const LightGrayBackground = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const DividerSectionWrapper = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`

export default ChannelView
